import angular from 'angular';
import { EditPayrollPolicyComponent } from './edit-payroll-policy.component';
import { EditRotationPolicyComponent } from './edit-rotation-policy.component';

export const PayrollPolicyModule = angular
    .module("apex.mainApp.payroll.policy", [])
    .component("apexEditPayrollPolicy", EditPayrollPolicyComponent)
    .component("apexEditRotationPolicy", EditRotationPolicyComponent)
    .name;
